/**
 * /devhub/settings — Operator layout & white-label settings. Surface Layer (/01).
 *
 * REQ-001.91 DevHub UI rebuild · Phase 2 (already-live domains). Reuses the live `DevHubLayoutSettings`
 * panel (persisted via `PATCH /api/user-settings`). Operator-only (routePolicy plane guard + the panel's
 * own `roleIsOperator` gate, fed from entitlements here).
 */

import { createFileRoute } from '@tanstack/react-router';

import { useEntitlements } from '@lib/persistence/useEntitlements';
import { DevHubLayoutSettings } from '../components/settings/DevHubLayoutSettings';

export const Route = createFileRoute('/devhub/settings')({ component: DevHubSettingsPage });

function DevHubSettingsPage() {
  const { isElevated } = useEntitlements();

  return (
    <main className="view">
      <header className="view__header">
        <h1 className="view__title">Settings</h1>
        <p className="view__subtitle">Operator layout and white-label preferences (live /api/user-settings).</p>
      </header>

      <DevHubLayoutSettings roleIsOperator={isElevated} />
    </main>
  );
}
